/* eslint-disable */
import React, { FC, useState, useEffect } from "../../../lib/teact/teact";
import Checkbox from "../../ui/Checkbox";
import ConfirmDialog from "../../ui/ConfirmDialog";
import Radio from "../../ui/Radio";
import RadioGroup from "../../ui/RadioGroup";
import { GetKetQuaFromServer } from "../db/service/ketquaService";
import { TinhThuongAllLocal } from "../db/service/parserService";
import ReportApi from "../restapi/reportApi";
import worker from "../setupWorker";
import store from "../store";
import { getCurDate, getDateString } from "../utils/DateTimeUtils";
import { isLocalMode } from "../utils/common";
import './formCommon.scss'
import LotCheckBox from "./lotCheckBox";
import Snackbar from "./snackbar";
type OwnProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

type ErrorProp = {
    errorItem: any;
}
const ErrorItem: FC<ErrorProp> = ({
    errorItem
}) => {
    return <tr>
        <td>{errorItem.Giai}</td>
        <td >
            <span >{errorItem.Nguon1}</span>
            <span >{errorItem.SoNguon1}</span>
            <span >{errorItem.Nguon2}</span>
            <span >{errorItem.SoNguon2}</span>
        </td>
    </tr>
}

const KqxsDialog: FC<OwnProps> = ({
    isOpen,
    onClose,
    onConfirm,
}) => {
    const [state, setState] = useState({
        ngay: store.getState().global.workDate,
        snackbarOpen: false,
        snackbarMessage: "",
        tinhThuong: true,
        nguon: "tinhThuong",
        showErorrDialog: false,
        errorText: "",
        ketQuaError: { ErrorItems: [], ThongBao: '' },
    })
   
    return (
        <div className="form-main">
            <ConfirmDialog
                title='Tải KQXS'
                isOpen={isOpen}

                onClose={() => onClose()} /* closeSignOutConfirmation */
                /* text={lang('lng_sure_logout')} */
                /*  confirmLabel={lang('AccountSettings.Logout')} */
                confirmLabel={'Tải'}
                confirmHandler={() => {
                    const payload = { ngay: state.ngay, nguon: state.nguon }
                    if (!isLocalMode()) {
                        /* ReportApi.postBuildKetQua(payload).then(result => {
                            setState(prev => ({ ...prev, snackbarMessage: "Đã tải xong kết quả", snackbarOpen: true }))
                            if (state.tinhThuong) {
                                setState(prev => ({
                                    ...prev,
                                    snackbarMessage: "Đang tính thưởng, vui lòng chờ đến khi có thông báo hoàn thành",
                                    snackbarOpen: true
                                }))
                                ReportApi.postTinhThuong(payload).then(rslt => {
                                    setState(prev => ({ ...prev, snackbarMessage: rslt.responseText, snackbarOpen: true }))
                                })
                            }
                        }) */
                        worker.postMessage({
                            type: 'showsnackbar', data: 'Đang tính thưởng, vui lòng chờ tới khi có thông báo hoàn thành!',
                            options: { duration: 60000, closeable: false }
                        })
                        ReportApi.postTinhThuong(payload).then(rslt => {
                            //setState(prev => ({ ...prev, snackbarMessage: rslt.responseText, snackbarOpen: true }))
                            if (rslt.dataEx) {
                                if (rslt.dataEx.ThongBao) {
                                    setState(prev => ({
                                        ...prev, showErorrDialog: true,
                                        errorText: rslt.dataEx.ThongBao, ketQuaError: rslt.dataEx
                                    }))
                                    
                                }
                            }
                            worker.postMessage({
                                        type: 'showsnackbar', data: rslt.responseText,
                                        options: { duration: 60000, closeable: false }
                                    })
                        })
                    }
                    else {
                        worker.postMessage({ type: 'showsnackbar', data: 'Đang tải kết quả, vui lòng chờ' })
                        GetKetQuaFromServer(state.ngay).then((res) => {
                            if (state.tinhThuong) {
                                worker.postMessage({ type: 'showsnackbar', data: 'Đang tải tính thưởng, vui lòng chờ' })
                                TinhThuongAllLocal(state.ngay).then((count) => {
                                    worker.postMessage({ type: 'showsnackbar', data: 'Đã tính thưởng xong:' + count + ' bản ghi' })
                                })
                            }
                        })
                    }
                    onConfirm()
                }}>
                <div className="kqxs-dialog-main">
                    <div className="kqxs-dialog-main row">
                        <div>Ngày</div>
                        <input type='date' value={state.ngay} className="date-input"
                            onChange={(e) => {
                                setState(prev => ({ ...prev, ngay: e.target.value }))
                            }}
                        />
                    </div>

                    <RadioGroup
                        name="chonNguon"
                        selected={state.nguon}
                        onChange={(value, e) => {
                            setState(prev => ({ ...prev, nguon: value }))
                        }}
                        options={[
                            { label: "Chỉ tính thưởng", value: "tinhThuong" },
                            { label: "Nguồn 1", value: "nguon1" },
                            { label: "Nguồn 2", value: "nguon2" },

                        ]
                        }
                    ></RadioGroup>



                    {/* <div className="kqxs-dialog-main row">
                        <LotCheckBox text="Tính thưởng sau khi tải KQXS"
                            disabled={state.nguon=="tinhThuong"}
                            checked={state.tinhThuong}
                            onChange={(e) => { setState(prev => ({ ...prev, tinhThuong: e.target.checked })) }}
                        />
                    </div> */}
                </div>

            </ConfirmDialog>
            <ConfirmDialog title="Cảnh báo !"
                isOpen={state.showErorrDialog}
                onClose={() => { }}
                confirmHandler={() => { setState(prev => ({ ...prev, showErorrDialog: false })) }}
                confirmLabel="Đóng"
                isOnlyConfirm={true}
                className=" modal-header-condensed danger"
            >
                <div className="danger">
                    {state.errorText}
                    {state.ketQuaError && state.ketQuaError.ErrorItems &&
                        state.ketQuaError.ErrorItems.length > 0 &&
                        <>
                            <div>Danh sách kết quả không khớp</div>
                            <div>
                                {state.ketQuaError.ErrorItems.map((item, index) => {
                                    return <ErrorItem key={index} errorItem={item} />
                                }
                                )}
                            </div>
                        </>}
                </div>
            </ConfirmDialog>
            <Snackbar isOpen={state.snackbarOpen} message={state.snackbarMessage}
                triggerTime={JSON.stringify(new Date())}
                onClose={() => { setState(prev => ({ ...prev, snackbarOpen: false })) }}

            />
        </div>

    )
}

export default KqxsDialog;